import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { BasePage } from './base.page';


export class BaseDialog extends BasePage {

    savedInstance = false
    
    constructor(
        public modalCtrl: ModalController,
        public router: Router) {
            super(router)
        }

    closeDialog() {
        this.modalCtrl.dismiss();
    }

    ngOnInit() {
        this.savedInstance = true
    }

    ionViewDidLeave() {
        this.savedInstance = false
    }
}
